import React from 'react';
import { PrismicRichText } from '@prismicio/react';

export const ResourceStats = (props) => {


    const items = props.slice.items;


    return (
        <section className="gutter sm res-sec">
            <div className="wrapper gutter top sm">
                <div className="flex flex-col md:flex-row gap-2 md:gap-12 justify-between">
            {items && items.map((item, index) => (
                <div key={index} className={"flex flex-col justify-center items-center bg-grey-light p-6 rounded-lg w-full text-center cs-stats-item stat " + item.theme}>
                  <div className={"text-4xl font-avebold mb-2 text-" + item.theme}>{item.stat_number}</div>
                  <PrismicRichText field={item.stat_content.richText} />
                </div>
              ))}
              </div>
            </div>
        </section>
    );
}

